/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_No_Active_CargosInputs */

const en_audit_no_active_cargos = /** @type {(inputs: Audit_No_Active_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active cargos found for this location.`)
};

const es_audit_no_active_cargos = /** @type {(inputs: Audit_No_Active_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron cargas activas para esta ubicacion.`)
};

/**
* | output |
* | --- |
* | "No active cargos found for this location." |
*
* @param {Audit_No_Active_CargosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_no_active_cargos = /** @type {((inputs?: Audit_No_Active_CargosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_No_Active_CargosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_no_active_cargos(inputs)
	return es_audit_no_active_cargos(inputs)
});